/** "Send a quick message" — type, press Enter, land in the thread. */
import { useState, type FormEvent } from 'react';
import { SendHorizontal } from 'lucide-react';
import { IconButton, Input } from '@cyphex/ui';
import type { UserId } from '@cyphex/types';
import { useQuickMessage } from '../hooks/useQuickMessage';

export interface ProfileQuickMessageProps {
  userId: UserId;
  displayName: string;
  /** Called once the message is away and the router has moved. */
  onSent?: () => void;
}

export function ProfileQuickMessage({ userId, displayName, onSent }: ProfileQuickMessageProps) {
  const [text, setText] = useState('');
  const { send, isSending } = useQuickMessage();
  const empty = text.trim() === '';

  const submit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void send(userId, text).then((ok) => {
      if (!ok) return;
      setText('');
      onSent?.();
    });
  };

  return (
    <form onSubmit={submit}>
      <Input
        label={`Send a quick message to ${displayName}`}
        hideLabel
        placeholder="Send a quick message"
        value={text}
        disabled={isSending}
        onChange={(event) => setText(event.target.value)}
        trailing={
          <IconButton
            icon={SendHorizontal}
            label="Send message"
            size="sm"
            variant="ghost"
            type="submit"
            disabled={empty || isSending}
          />
        }
      />
    </form>
  );
}
